export const API_KEY = process.env.REACT_APP_MAP_API_KEY;

// --- Brand palette: white + light green (Material Design) ---
// THEME_COLOR  : primary brand accent (sidebar, active states, light buttons)
// ACTION_GREEN : deeper green for solid buttons/loaders that need white text
// APP_BG       : near-white app background (white surfaces sit on top)
export const THEME_COLOR = "#8BC34A"; // Material Light Green 500
export const ACTION_GREEN = "#558B2F"; // Material Light Green 800
export const APP_BG = "#F4F7F2";
export const THEME_COLOR2 = "#f14136";
export const THEME_COLOR3 = "#AAA";
export const THEME_COLOR4 = "#C4C4C4";
export const THEME_COLOR5 = "#272D2F";
export const LOADING_COLOR = "#558B2F";
export const BTN_COLOR = "#000000";
export const BTN_TEXT_COLOR = "#FFF";
export const TEXT_SECONDARY_COLOR = "#888";

export const RESTAURANT_APP_URL = process.env.REACT_APP_RESTAURANT_APP_URL;

// Populated at app mount from /countries/all. Empty until initCountryData() runs.
export const CURRENCIES = [];
export const CURRENCY_SYMBOL_MAP = {};
// Maps country name → { code, symbol } for currency resolution in the data transformer.
export const COUNTRY_CURRENCY_MAP = {};

export const initCountryData = (rows) => {
  const activeRows = rows.filter(({ isActive }) => isActive);

  // Deduplicate by currency code (multiple countries can share one)
  const seenCurrencies = new Set();
  CURRENCIES.length = 0;
  activeRows.forEach(({ name, currency, currencySymbol }) => {
    if (!seenCurrencies.has(currency)) {
      seenCurrencies.add(currency);
      CURRENCIES.push({ code: currency, symbol: currencySymbol, name });
    }
  });

  // Sync CURRENCY_SYMBOL_MAP
  Object.keys(CURRENCY_SYMBOL_MAP).forEach((k) => delete CURRENCY_SYMBOL_MAP[k]);
  CURRENCIES.forEach(({ code, symbol }) => { CURRENCY_SYMBOL_MAP[code] = symbol; });

  // Sync COUNTRY_LIST
  COUNTRY_LIST.length = 0;
  activeRows.forEach(({ name }) => COUNTRY_LIST.push(name));

  // Sync COUNTRY_CURRENCY_MAP — keyed by country name
  Object.keys(COUNTRY_CURRENCY_MAP).forEach((k) => delete COUNTRY_CURRENCY_MAP[k]);
  activeRows.forEach(({ name, currency, currencySymbol }) => {
    COUNTRY_CURRENCY_MAP[name] = { code: currency, symbol: currencySymbol };
  });
};

// Helper function to format price with correct decimal places
export const formatPrice = (value, currency) => {
  const numValue = parseFloat(value);
  if (isNaN(numValue)) {
    return '0.00';
  }
  const decimalPlaces = currency === 'BHD' ? 3 : 2;
  return numValue.toFixed(decimalPlaces);
};

export const MENU_TYPE = [
  "None",
  "Non vegetarian",
  "Vegetarian",
  "Plant based",
  "Seafood",
];

export const DINEIN = 1;
export const DELIVERY = 2;
export const PICKUP = 3;
export const TABLE = 4;

export const APP_TYPE_FOODO = "FOODO";
export const APP_TYPE_GOPOSH = "GOPOSH";
export const APP_TYPE_BOTH = "BOTH";

export const COUNTRY_LIST = [];

export const VAT_VAL = 20;
export const VAT_NUM_VAL = 9999999;

export const AR_CATEGORY_GROUP_POSITION = [
  { label: "Top", value: "top" },
  { label: "Bottom", value: "bottom" },
];

export const ROLE_NAMES = {
  superAdmin: "Super Admin",
};

export const UNGROUPED = "UNGROUPED";

export const FOOTER_XPADDING = { light: 1.5, dark: 0 };

export const COURSE_TYPE_LIST = [
  { label: "STARTER", value: "STARTER" },
  { label: "MAINS", value: "MAINS" },
  { label: "DESSERTS", value: "DESSERTS" },
  { label: "DRINKS", value: "DRINKS" },
  { label: "NONE", value: "NONE" },
];

export const IS_LARGE_SCREEN = document.documentElement.clientWidth >= 1920;
export const NAVBAR_HEIGHT = IS_LARGE_SCREEN ? 90 : 64;

export const SPLIT_PAYMENT_METHOD = {
  cash: 1,
  ecash: 2,
  card: 3,
  giftcard: 4,
  invoice: 5,
};

export const RESTAURANT_ADMIN_ROLE_ID = process.env.REACT_APP_RESTAURANT_ADMIN_ROLE_ID;
export const RESTAURANT_USER_ROLE_ID = process.env.REACT_APP_RESTAURANT_USER_ROLE_ID;
export const USER_ROLE_LIST = [
  { label: "Admin", value: RESTAURANT_ADMIN_ROLE_ID },
  { label: "User", value: RESTAURANT_USER_ROLE_ID },
];